import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 px-4 max-w-5xl mx-auto scroll-mt-16" data-id="element-234">
      <div className="text-center mb-12" data-id="element-235">
        <h2 className="text-2xl font-bold text-zinc-400 mb-6 flex items-center justify-center gap-2" data-id="element-236">
          <span data-id="element-237">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>

        <div className="mb-8" data-id="element-238">
          <Countdown data-id="element-239" />
        </div>

        <div className="inline-block bg-red-500/10 border border-red-500/20 text-red-400 px-6 py-3 rounded-xl font-bold mb-8" data-id="element-240">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </div>

        <div className="max-w-md mx-auto mb-16" data-id="element-241">
          <div className="flex justify-between text-sm mb-2 font-bold" data-id="element-242">
            <span className="text-red-400 flex items-center gap-1" data-id="element-243">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-zinc-400" data-id="element-244">Quedan pocos</span>
          </div>
          <div className="h-3 bg-surface rounded-full overflow-hidden border border-zinc-800" data-id="element-245">
            <div className="h-full bg-red-500 w-[68%] rounded-full" data-id="element-246"></div>
          </div>
          <div className="text-xs text-zinc-500 mt-2 text-right" data-id="element-247">
            68% de los cupos ya tomados
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-12" data-id="element-248">
          ELEGÍ TU COMBO COMPLETO
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-249">
        {/* Card 1 */}
        <div className="bg-surface border border-zinc-800 rounded-3xl p-8 flex flex-col relative" data-id="element-250">
          <div className="mb-6" data-id="element-251">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-252">
              <span data-id="element-253">📘</span> COMBO COMPLETO
            </h3>
            <p className="text-zinc-400 text-sm" data-id="element-254">6 Tomos + 6 Bonos</p>
          </div>

          <div className="bg-surface2 p-4 rounded-xl mb-6 text-sm text-zinc-300" data-id="element-255">
            <span className="font-bold text-white" data-id="element-256">Ideal para:</span> Profes que
            quieren resolver todo el año de clases con un sistema progresivo
            completo
          </div>

          <div className="mb-8 flex-grow" data-id="element-257">
            <div className="text-zinc-500 line-through text-xl font-bold mb-1" data-id="element-258">
              $51.000
            </div>
            <div className="text-5xl font-extrabold text-white mb-2" data-id="element-259">
              $19.990 <span className="text-2xl text-zinc-400" data-id="element-260">ARS</span>
            </div>
          </div>

          <Button href="https://www.compradigitalya.com/checkouts/cn/hWNBfCDdHQUTNK8tIikCUts2/es-ar?_r=AQAB1bvEcqlGPcyGyamgvjBgxYvtyuUNQZ9h35zPIFBVk78&cart_link_id=nZEWN4Xd&preview_theme_id=141062045767" fullWidth className="py-4 text-lg" data-id="element-261">
            → QUIERO MI COMBO COMPLETO
          </Button>
        </div>

        {/* Card 2 - Featured */}
        <div className="bg-surface border-2 border-primary rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(74,222,128,0.1)] transform md:-translate-y-4" data-id="element-262">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-black font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-263">
            <Star className="w-4 h-4 fill-black" data-id="element-264" /> MÁS ELEGIDO
          </div>

          <div className="mb-6" data-id="element-265">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-266">
              <span data-id="element-267">🏆</span> COMBO + NEGOCIO
            </h3>
            <p className="text-zinc-400 text-sm" data-id="element-268">
              6 Tomos + 6 Bonos + Upsell Premium
            </p>
          </div>

          <div className="bg-primary/10 border border-primary/20 p-4 rounded-xl mb-6 text-sm text-zinc-300" data-id="element-269">
            <span className="font-bold text-white" data-id="element-270">Ideal para:</span> Profes que
            además quieren construir un negocio rentable, cobrar lo que valen y
            llenar sus grupos
          </div>

          <div className="mb-8 flex-grow" data-id="element-271">
            <div className="text-zinc-500 line-through text-xl font-bold mb-1" data-id="element-272">
              $76.000
            </div>
            <div className="text-5xl font-extrabold text-white mb-2" data-id="element-273">
              $27.990 <span className="text-2xl text-zinc-400" data-id="element-274">ARS</span>
            </div>
          </div>

          <Button href="https://www.compradigitalya.com/checkouts/cn/hWNBdUFFymDYbXpYXXycWa3O/es-ar?_r=AQAB9ZpcoTmOvmIKllCe542nTswrOhwYIuaMfsTG0ScpiM8&cart_link_id=S2jicxQP&preview_theme_id=141062045767" fullWidth className="py-4 text-lg shadow-[0_0_20px_rgba(74,222,128,0.3)]" data-id="element-275">
            → QUIERO EL COMBO + NEGOCIO
          </Button>
        </div>
      </div>
    </section>;
}